<!--
    @修改人：谢汉
    @修改时间：2019-01-09
    @修改描述：优化密码修改
    @版本:v2.0.0
    ------------
    @修改人：黎柏祺
    @修改时间：2018-12-14
    @修改描述：框架升级
    @版本:v1.0.26
    ------------
    @修改人：谢汉
    @修改时间：2018-10-19
    @修改描述：新增密码验证功能
    @版本:v1.0.24
    --------
    @负责人: 邱凤云
    @创建时间: 2018-01-18
    @版本:v1.0.12
    @描述: 用户管理页面
    -->
<template>
  <div class="userManage__content">
    <div class="userManage__form">
      <el-form ref="form"
        :model="form"
        :inline="true"
        input-width="auto">
        <el-form-item :label="$t('userManage.userName')">
          <el-input v-model="form.userName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
            @click="e_search"
            v-g-rac="gRac('userManage_search')">{{ $t('common.search') }}</el-button>
          <el-button type="primary"
            @click="e_addUser()"
            v-g-rac="gRac('userManage_add')">{{ $t('userManage.add') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table-extend :data="tData"
      :head="tHead"
      :currentChange="tCurrentChange"
      :sizeChange="tSizeChange"
      border>
      <template slot="control-column"
        slot-scope="{data}">
        <el-table-extend-control :control="tableControl"
          :data="data"
          :label="$t('common.handle')">
        </el-table-extend-control>
      </template>
    </el-table-extend>
    <el-dialog :closeOnClickModal="false"
      :title="dialogTitle"
      :visible.sync="dialogFormShow"
      width="400px">
      <el-form label-position="right"
        label-width="80px"
        :model="userInfo"
        :rules="userInfoRule"
        ref="userInfoForm">
        <el-form-item :label="$t('userManage.userName')"
          prop="userName">
          <el-input v-model="userInfo.userName"
            :disabled="isAmend"></el-input>
        </el-form-item>
        <el-form-item :label="$t('userManage.realName')"
          prop="realName">
          <el-input v-model="userInfo.realName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('userManage.password')"
          prop="password"
          :inline-message="true">
          <el-input v-model="userInfo.password"
            type="password"
            @change="changePassword"></el-input>
        </el-form-item>
        <el-form-item :label="$t('userManage.confirmPassword')"
          prop="confirmPassword"
          :inline-message="true">
          <el-input v-model="userInfo.confirmPassword"
            type="password"
            @change="changePassword"></el-input>
        </el-form-item>
        <el-form-item :label="$t('userManage.phoneNum')"
          prop="phoneNum">
          <el-input v-model.number="userInfo.phoneNum"></el-input>
        </el-form-item>
        <el-form-item :label="$t('userManage.email')"
          prop="email">
          <el-input v-model="userInfo.email"></el-input>
        </el-form-item>
        <el-form-item :label="$t('userManage.group')"
          prop="group">
          <el-select v-model="userInfo.group">
            <el-option v-for="(item, key) in select_group"
              :label="item"
              :value="key"
              :key="key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="enabled"
          input-width="auto">
          <el-radio-group v-model="userInfo.enabled">
            <el-radio :label="true">{{ $t('userManage.beUse') }}</el-radio>
            <el-radio :label="false">{{ $t('userManage.stopUse') }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer"
        class="dialog-footer">
        <el-button @click="dialogFormShow = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary"
          @click="e_save">{{ $t('common.confirm') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :closeOnClickModal="false"
      :title="$t('userManage.assignRole')"
      :visible.sync="dialogVisible"
      width="600px">
      <el-form :model="userForm"
        label-position="right"
        label-width="80px"
        ref="userForm"
        :inline="true">
        <el-form-item :label="$t('userManage.roleName')">
          <el-input v-model="userForm.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
            @click="e_roleSearch"
            v-g-rac="gRac('roleManage_search')">{{$t('common.search')}}</el-button>
        </el-form-item>
        <el-form-item input-width="550px">
          <el-table :data="tableData"
            border
            style="width: 100%">
            <el-table-column prop="name"
              :label="$t('userManage.table.name')">
            </el-table-column>
            <el-table-column prop="description"
              :label="$t('userManage.table.description')">
            </el-table-column>
            <el-table-column :label="$t('common.handle')">
              <template slot-scope="scope">
                <el-button type="text"
                  size="small"
                  v-g-rac="gRac('userManage_addrole')"
                  @click="e_addRole(scope.row)">{{ $t('securityRole.add') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item input-width="550px">
          <div class="user-wrap"
            v-show="selectUsers.length > 0">
            <div class="each-machine"
              v-for="(item, index) in selectUsers"
              :key="index"
              :title="item.name">
              <i class="icon iconfont icon-amc_circle_close icon-delete"
                @click="deleteRole(index)"></i>
              <span v-text="item.name"></span>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer"
        class="dialog-footer">
        <el-button @click="resetForm">{{$t('common.cancel')}}</el-button>
        <el-button type="primary"
          @click="e_saveRole">{{$t('common.save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script >
import rac from "@/plugins/rac-mixin";
import dic from "@/components/mixins/dic";
import table from "@/components/mixins/table";
import userManageBiz from "@/logic/systemSetting/userManageBiz";
import roleManageBiz from "@/logic/systemSetting/roleManageBiz";
import dialogForm from "@/components/dialogForm";
import repertoryBiz from "@/logic/cmdb/repertoryBiz";
import { extend } from "@/utils/tool";
import MD5 from "md5";
import TimeFormat from "@/utils/timeFormat";

export default {
  mixins: [rac, dic, table],
  components: {
    dialogForm
  },
  data() {
    const that = this;
    let checkNewPwd = pwd => {
      let vs = true;
      let regArr = [/^[\u0021-\u007e]{8,20}$/, /[0-9]/, /[a-z]/, /[A-Z]/, /\W/];
      for (let i = 0; i < regArr.length; i++) {
        if (!regArr[i].test(pwd)) {
          vs = false;
          break;
        }
      }
      return vs;
    };
    let passwordRule = (rule, value, callback) => {
      if (!this.checkPassword) {
        callback();
        return;
      }
      if (!checkNewPwd(value)) {
        callback(new Error(this.$t("header.checkPwd")));
      } else {
        if (this.userInfo.password !== "") {
          this.$refs.userInfoForm.validateField("confirmPassword");
        }
        callback();
      }
    };
    let confirmPasswordRule = (rule, value, callback) => {
      if (!this.checkPassword) {
        callback();
        return;
      }
      if (!checkNewPwd(value)) {
        callback(new Error(this.$t("header.checkPwd")));
      } else if (value !== this.userInfo.password) {
        callback(new Error(this.$t("header.passSameAlert")));
      } else {
        callback();
      }
    };
    return {
      form: {
        userName: ""
      },
      userForm: {
        name: ""
      },
      tableData: [],
      dialogVisible: false,
      selectUsers: [],
      tableControl: [
        {
          label: that.$t("common.delete"),
          callback: that.e_delete,
          rac: () => that.gRac("userManage_delete")
        },
        {
          label: that.$t("common.edit"),
          callback: that.e_addUser,
          rac: () => that.gRac("userManage_amend")
        },
        {
          label: that.$t("userManage.authorize"),
          callback: that.e_authorize,
          rac: () => that.gRac("userManage_distribute")
        }
      ],
      dialogFormShow: false,
      dialogTitle: "",
      select_group: {},
      saveRoleID: null,
      enableList: {
        true: that.$t("userManage.beUse"),
        false: that.$t("userManage.stopUse")
      },
      userInfoRule: {
        userName: [
          { required: true, message: this.$t("userManage.userNameTips") }
        ],
        realName: [
          { required: true, message: this.$t("header.realNameAlert") }
        ],
        password: [
          {
            required: true,
            message: this.$t("userManage.pleaseInputPassword")
          },
          { validator: passwordRule }
        ],
        confirmPassword: [
          { required: true, message: this.$t("userManage.rePassword") },
          { validator: confirmPasswordRule }
        ],
        phoneNum: [
          { required: true, message: this.$t("header.phoneNumAlert") },
          { type: "number", message: this.$t("header.phoneCorrect") }
        ],
        email: [
          {
            required: true,
            message: this.$t("header.emailAlert"),
            trigger: "blur"
          },
          {
            type: "email",
            message: this.$t("header.emailCorrect"),
            trigger: ["blur", "change"]
          }
        ]
      },
      userInfo: {
        userName: "",
        realName: "",
        password: "",
        confirmPassword: "",
        phoneNum: "",
        email: "",
        group: "",
        enabled: true
      },
      isAmend: false,
      checkPassword: false,
      selectId: ""
    };
  },
  methods: {
    deleteRole(index) {
      this.selectUsers.splice(index, 1);
    },
    getGroup() {
      repertoryBiz
        .getInstance({
          currentPage: 1,
          perPageCount: 999,
          flagId: "t_department",
          resourceType: "4"
        })
        .then(d => {
          let obj = {};
          d.dataList.map(item => {
            obj[item.code] = item.name;
          });
          this.select_group = obj;
        });
    },
    initTable() {
      this.tInitTable({
        lanKey: "userManage.table",
        head: [
          "userName",
          "roleList",
          "source",
          "phoneNum",
          "email",
          "enabled",
          "creator",
          "createTime"
        ],
        requestFun: this.search,
        headOpt: {
          enabled: {
            formatter: "Dictionary",
            formatterDic: this.enableList
          }
        }
      });
    },
    search() {
      const reqData = extend(true, { ...this.tPageInfo }, this.form);
      userManageBiz.findUser(reqData).then(data => {
        data.dataList.map(item => {
          item.source =
            item.source === "0" ? this.$t("userManage.ops") : item.source;
          item.roleList = item.roleList.join(",");
          item.createTime = TimeFormat.getFormatTime(item.createTime);
        });
        this.tData = data;
      });
    },
    e_search() {
      this.tResetPage();
      this.search();
    },
    e_delete(rowData) {
      this.$confirm(this.$t("common.deleteTips"), this.$t("common.tips"), {
        type: "warning"
      }).then(() => {
        userManageBiz
          .deleteUser({
            id: rowData.id
          })
          .then(data => {
            this.$message({
              message: this.$t("common.success"),
              type: "success"
            });
            this.search();
          });
      });
    },
    changePassword() {
      this.checkPassword = true;
    },
    e_addUser(rowData) {
      this.isAmend = rowData !== undefined;
      this.checkPassword = false;
      if (this.isAmend) {
        this.selectId = rowData.id;
        this.userInfo = {
          userName: rowData.userName,
          realName: rowData.realName,
          password: "passwordnotchange",
          confirmPassword: "passwordnotchange",
          phoneNum: Number(rowData.phoneNum),
          email: rowData.email,
          group: rowData.group,
          enabled: rowData.enabled === this.$t("userManage.beUse")
        };
      } else {
        this.userInfo = {
          userName: "",
          realName: "",
          password: "",
          confirmPassword: "",
          phoneNum: "",
          email: "",
          group: Object.keys(this.select_group)[0],
          enabled: true
        };
      }
      this.dialogTitle =
        rowData !== undefined
          ? this.$t("userManage.amendUserInfo")
          : this.$t("userManage.addUserInfo");
      this.dialogFormShow = true;
      this.$nextTick(() => {
        this.$refs["userInfoForm"].clearValidate();
      });
    },
    e_authorize(rowData) {
      this.selectUsers = [];
      this.dialogVisible = true;
      this.saveRoleID = rowData.id;
      this.tableData.map(item => {
        rowData.roleList.split(",").map(i => {
          if (item.name === i) {
            this.selectUsers.push({ id: item.id, name: item.name });
          }
        });
      });
    },
    e_save() {
      debugger;
      const data = extend(true, {}, this.userInfo);
      data.password = MD5(data.password);
      data.source = "0";
      delete data.confirmPassword;
      if (!this.checkPassword) {
        delete data.password;
        delete data.confirmPassword;
      }
      if (this.isAmend) data.id = this.selectId;
      let eventName = this.isAmend ? "amendUser" : "addUser";
      userManageBiz[eventName](data).then(res => {
        this.$message({
          message: this.$t("common.success"),
          type: "success"
        });
        this.dialogFormShow = false;
        this.e_search();
      });
    },
    e_roleSearch() {
      const reqData = extend(true, { perPageCount: 500 }, this.userForm);
      roleManageBiz.findAll(reqData).then(data => {
        this.tableData = data.dataList;
      });
    },
    e_addRole(rowData) {
      if (!this.selectUsers.some(item => item.id === rowData.id)) {
        this.selectUsers.push(rowData);
      }
    },
    resetForm() {
      this.dialogVisible = false;
    },
    e_saveRole() {
      const addList = [];
      this.selectUsers.forEach(item => {
        addList.push(item.id);
      });
      const addData = {
        id: this.saveRoleID,
        roleList: addList
      };
      userManageBiz.distributeUser(addData).then(res => {
        this.$message({
          message: this.$t("common.success"),
          type: "success"
        });
        this.dialogVisible = false;
        this.selectUsers = [];
        this.e_search();
      });
    }
  },
  mounted() {
    this.initTable();
    this.search();
    this.e_roleSearch();
    this.getGroup();
  }
};
</script>
<style>
.userManage__content .user-wrap {
  border: 1px solid #ddd;
  width: 100%;
}
.userManage__content .each-machine {
  width: 135px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  display: inline-block;
  position: relative;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0);
}
.userManage__content .each-machine:hover {
  background: #eaeaea;
  border: 1px solid #ddd;
}
.userManage__content .each-machine:hover .icon-delete {
  display: block;
}
.userManage__content .icon-delete {
  display: none;
  color: #a0a0a0;
  font-size: 18px;
  position: absolute;
  bottom: 16px;
  right: -8px;
}
.userManage__content .icon-delete:hover {
  color: #3385ff;
}
</style>
